var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIconNewFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_add_bg",
    opacity: 0.6,
    fillRule: "evenodd",
    d: "M15 28.75C22.5939 28.75 28.75 22.5939 28.75 15C28.75 7.40608 22.5939 1.25 15 1.25C7.40608 1.25 1.25 7.40608 1.25 15C1.25 22.5939 7.40608 28.75 15 28.75ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "place_icon_add_icon",
    d: "M15.7505 9.5C15.7505 9.08579 15.4147 8.75 15.0005 8.75C14.5863 8.75 14.2505 9.08579 14.2505 9.5V14.2505H9.5C9.08579 14.2505 8.75 14.5863 8.75 15.0005C8.75 15.4147 9.08579 15.7505 9.5 15.7505H14.2505V20.5C14.2505 20.9142 14.5863 21.25 15.0005 21.25C15.4147 21.25 15.7505 20.9142 15.7505 20.5V15.7505H20.5C20.9142 15.7505 21.25 15.4147 21.25 15.0005C21.25 14.5863 20.9142 14.2505 20.5 14.2505H15.7505V9.5Z"
  })));
}
export default SvgPlaceIconNewFolder;